import { combineReducers } from "redux"

// Front
import Ong from "./register/ong/reducer"
import Layout from "./layout/reducer"
import Document from "./documents/reducer"
import LedgerProfile from "./ledger/reducer"
import Passager from "./register/passager/reducer"
import Provider from "./register/provider/reducer"
import Policie from "./policies/reducer"

const rootReducer = combineReducers({
  // public
  Ong,
  Layout,
  Passager,
  Provider,
  Document,
  LedgerProfile,
  Policie,
})

export default rootReducer
